import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
type Item = {
  title: string;
  body: string;
  img?: string;
};
type Props = {
  items: Item[];
  defaultOpen?: number | null;
};
export function Accordion({
  items,
  defaultOpen = 0
}: Props) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  return <div className="flex flex-col gap-3" data-id="element-107" data-mp="2n3frslurrnm9">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={i} className="overflow-hidden rounded-2xl border border-[#1f4d3a]/15 bg-white/95 shadow-sm" data-id="element-108" data-mp="2i42vzblx767j" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-109" data-mp="2s3248t2rwzu0">
              <span className="text-[15px] font-bold text-[#1f4d3a]" data-id="element-110" data-mp="xqc9k94kzmlk">
                {item.title}
              </span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#2f6b4f] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} data-id="element-111" data-mp="3g5x2k3jz111b" />
            </button>
            <AnimatePresence initial={false} data-id="element-112" data-mp="3ut05ipr2c1w1">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.28,
            ease: "easeInOut"
          }} className="overflow-hidden" data-id="element-113" data-mp="3uv33px2dd1bu">
                  <div className="px-4 pb-4 pt-0" data-id="element-114" data-mp="hm840y0st45e">
                    {item.img && <img src={item.img} alt={item.title} className="mb-3 w-full rounded-xl object-cover" loading="lazy" data-id="element-115" data-mp="2eeqefnvfrz1i" />}
                    <p className="text-sm leading-relaxed text-slate-600" data-id="element-116" data-mp="2bdnieishi7t7">
                      {item.body}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}